var _defs, _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalloonRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e04848;}.cls-2{fill:none;stroke:#ccc;stroke-miterlimit:10;}.cls-3{fill:#b70404;}.cls-4{fill:#a50808;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32,
    cy: 23.81,
    r: 20.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,.86a22.92,22.92,0,0,1,22.5,18,23.35,23.35,0,0,1-1.21,13.65A81.61,81.61,0,0,1,41,54.16,58.65,58.65,0,0,1,32.4,63a.54.54,0,0,1-.77.06L31.57,63a52.41,52.41,0,0,1-7.5-7.24A74.57,74.57,0,0,1,10.2,31.08,22.91,22.91,0,0,1,32,.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.89,19A22.42,22.42,0,0,0,32,1.25,21.93,21.93,0,0,0,21.25,4,22.66,22.66,0,0,0,10.76,31,73.94,73.94,0,0,0,24.27,55.36a52.7,52.7,0,0,0,7.24,7.24.54.54,0,0,0,.76,0l.06,0a57.73,57.73,0,0,0,8.44-8.68A81.06,81.06,0,0,0,52.69,32.58,23.49,23.49,0,0,0,53.89,19Zm-22,23.56A18.8,18.8,0,1,1,50.63,23.72v.11A18.77,18.77,0,0,1,31.92,42.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.42,13.75c1.7,0,3.83-.11,5.93.06,2.3.18,4.11,1.59,4.12,3.18v7.38c0,.38-.15.48-.67.46H37.6c-.47,0-.6-.09-.6-.42V19c0-.56-.29-.83-.9-.9-.81-.11-1.35.21-1.36.82v5.39c0,.41-.17.51-.75.49H29.87c-.54,0-.69-.08-.69-.46V19c0-.55-.35-.85-1-.88s-1.2.24-1.2.8v5.38c0,.42-.15.57-.8.56H22c-.41,0-.63,0-.63-.39V17c0-1.84,2.19-3.24,5-3.26C28.37,13.73,30.17,13.75,32.42,13.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.78,33.11a7.57,7.57,0,0,1-6.34-7.47v-.45H21.88a.46.46,0,0,0-.44.46v0c.45,7.89,5.95,10.4,8.82,11.17l.51.09Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.1,25.19H39.53v.45a7.58,7.58,0,0,1-6.19,7.45v3.82l.35-.07c2.87-.77,8.37-3.28,8.82-11.17A.45.45,0,0,0,42.1,25.19Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonRed);
export default __webpack_public_path__ + "static/media/balloon_red.8dfc125a24801799b6e77ab56fb2620c.svg";
export { ForwardRef as ReactComponent };